import React from 'react';
import ModalHeader from './modal/ModalHeader';
import ModalButtons from './modal/ModalButtons';
import {
    ModalOverlay,
    ModalContent
} from '../styles/ConfirmationModal.styles';

const ConfirmationModal = ({
    title,
    message,
    onConfirm,
    onCancel,
    confirmText,
    cancelText
}) => {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onCancel();
        }
    };

    return (
        <ModalOverlay onClick={handleOverlayClick}>
            <ModalContent>
                <ModalHeader
                    title={title}
                    message={message}
                />
                <ModalButtons
                    onPrimaryClick={onConfirm}
                    onSecondaryClick={onCancel}
                    primaryText={confirmText}
                    secondaryText={cancelText}
                    isDanger={true}
                />
            </ModalContent>
        </ModalOverlay>
    );
};

ConfirmationModal.defaultProps = {
    title: 'Confirm Action',
    message: 'Are you sure you want to proceed?',
    confirmText: 'Delete',
    cancelText: 'Cancel',
    onConfirm: () => { },
    onCancel: () => { }
};

export default ConfirmationModal;